import Link from "next/link";

import { withBasePath } from "@/lib/base-path";

export function HomepageLogo() {
  return (
    <Link
      href="/"
      aria-label="Product Experts"
      lang="en"
      className="shrink-0 flex items-center gap-1"
    >
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={withBasePath("/product-experts-logo.svg")}
        className="size-5"
        aria-hidden="true"
      />
      <span className="text-[#011E41] font-semibold leading-5">
        Product Experts
      </span>
    </Link>
  );
}
